import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ContentShellConfig } from '../shared/models/content-shell-config.model';
import { SharedModule } from '../shared/shared.module';
import { ContentShellRoutingModule } from './content-shell-routing.module';
import { ContentShellComponent } from './content-shell.component';
import { contentShellConfig } from './content-shell.config';
import { NotificationComponent } from './notification/notification.component';
import { RegretPageComponent } from './regret-page/regret-page.component';
import { TokenExpiryNotifyComponent } from './token-expiry-notify/token-expiry-notify.component';

@NgModule({
  declarations: [
    NotificationComponent,
    ContentShellComponent,
    RegretPageComponent,
    TokenExpiryNotifyComponent
  ],
  imports: [
    ContentShellRoutingModule,
    SharedModule,
    TranslateModule.forChild()
  ],
  exports: [ContentShellComponent]
})
export class ContentShellModule {
  static forRoot(config: ContentShellConfig): ModuleWithProviders<ContentShellModule> {
    return {
      ngModule: ContentShellModule,
      providers: [{ provide: contentShellConfig, useValue: config }]
    };
  }
}
